//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//component
const { RetailLoanImageGallery } = require('../retailLoanImageGallery/retailLoanImageGallery');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
const { buildEventClickProductName } = require('../../../../loansUtilities/loansHelper');
//@constants
const {
    retailLoanDoTaggin: { PRODUCT_IMAGE_VIEW },
} = require('../../../../loansConstants/index');

class RetailLoanImageGalleryContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            itemImageSeleted: null,
            indexImageSeleted: null,
            showModalFullImagen: false
        };

        this.handleChangeSelectedImage = this.handleChangeSelectedImage.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentWillMount() {
        const { listImages } = this.props;
        this.setState({
            itemImageSeleted: listImages.first(),
            indexImageSeleted: 0
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.indexImageSeleted !== nextState.indexImageSeleted
            || this.state.showModalFullImagen !== nextState.showModalFullImagen;
    }

    handleChangeSelectedImage(item, idx) {
        const { immRetailLoan, immItem } = this.props;
        const customData = buildEventClickProductName(immRetailLoan, immItem, PRODUCT_IMAGE_VIEW);
        recordLinkV2(customData);

        this.setState({
            itemImageSeleted: item,
            indexImageSeleted: idx
        });
    }

    handleToggleModal() {
        const { modalMoreInformation } = this.props;
        if (!modalMoreInformation) {
            this.setState({
                showModalFullImagen: !this.state.showModalFullImagen
            });
        }
    }

    render() {
        return (
            <RetailLoanImageGallery
                {...this.props}
                {...this.state}
                onHandleChangeSelectedImage={this.handleChangeSelectedImage}
                onHandleToggleModal={this.handleToggleModal}
            />
        );
    }
}

RetailLoanImageGalleryContainer.propTypes = {
    fullImage: PropTypes.bool,
    galleryPosition: PropTypes.string,
    immRetailLoan: PropTypes.object.isRequired,
    immItem: PropTypes.object.isRequired,
    isModal: PropTypes.bool,
    listImages: PropTypes.object.isRequired,
    mainImageWidth: PropTypes.number,
    modalMoreInformation: PropTypes.bool,
    zoom: PropTypes.bool,
    zoomSide: PropTypes.string,
};

export { RetailLoanImageGalleryContainer };
